import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { mergeMapTo } from 'rxjs/operators';
// import  firebase  from 'firebase/app';
// import 'firebase/messaging';
import { BehaviorSubject, Notification, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { SM_CONSTANTS } from '../shared/constants/sm-constants';
import { PushNotifications, Token, PushNotificationSchema, ActionPerformed } from '@capacitor/push-notifications';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  currentMessage = new BehaviorSubject<any>(null);

  constructor(private angularFireMessaging: AngularFireMessaging, private platform:Platform) {

  }
  requestPermission() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/firebase-cloud-messaging-push-scope',
      })
        .then((registration) => {
          console.log('Service Worker registered:', registration);
          this.requestFCMPermission();
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    } else {
      console.warn('Service Worker not supported in this browser or Incognito mode.');
    }
  }
  
  requestFCMPermission() {
    this.angularFireMessaging.requestPermission.subscribe(
      () => {
        console.log('Notification permission granted.');
        this.angularFireMessaging.requestToken.subscribe(
          (token) => {
            console.log('FCM Token:', token);
            if (token) {
              localStorage.setItem(SM_CONSTANTS.KEY_FCM_TOKEN, token);
            }
          },
          (err) => {
            console.error('Error getting FCM token', err);
          }
        );
      },
      (err) => {
        console.warn('Unable to get permission to notify.', err);
      }
    );
  }

  

receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload:any) => {
        console.log('new message received. ', payload);
          this.currentMessage.next(payload);
          // this.createNotification(payload.data.title, payload.data.message)
      });

    }
    createNotification(title:any, text:any) {
      console.log("hello");

      const noti = new Notification(title, {
        body: text,
      });
    }




    // FOR MOBILE SPECIFIC


}
